module.exports = __webpack_public_path__ + "img/conditioner.785d659d.svg";